'use strict';

var assetsLoader = require('./group');
assetsLoader.stats = require('./stats');

module.exports = assetsLoader;



/*****************
 ** WEBPACK FOOTER
 ** ./~/assets-loader/src/index.js
 ** module id = 6
 ** module chunks = 0
 **/